import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { DataserviceService } from 'src/app/dataservice.service';

export interface StarlinkSku {
  sku: string;
  label: string;
}

@Component({
  selector: 'app-starlink-catalog',
  templateUrl: './starlink-catalog.component.html',
  styleUrl: './starlink-catalog.component.css'
})
export class StarlinkCatalogComponent {

  @Input() fullData: any;
  @Output() catalogDone = new EventEmitter<{ reservedSku: any; nextPage: 'documents', workOrderId: string }>();

  catalogForm: FormGroup;
  availableSkus: StarlinkSku[] = [];
  reserveLoading = false;

  constructor(
    private fb: FormBuilder,
    private modal: NzModalService,
    private data: DataserviceService,
    private message: NzMessageService
  ) {
    this.catalogForm = this.fb.group({
      selectedSku: [null, Validators.required]
    });
  }

  ngOnInit(): void {
    this.loadSkus();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // console.log(this.fullData);
    if (changes['fullData'] && this.fullData?.catalog?.reservedSku && this.availableSkus.length) {
      this.ensureReservedSkuInListAndSelect();
    }
  }

  private ensureReservedSkuInListAndSelect(): void {
    if (!this.fullData?.catalog?.reservedSku) return;
    const rs = this.fullData.catalog.reservedSku.sku;
    const reservedObj = typeof rs === 'string' ? { sku: rs, label: rs } : rs;
    const exists = this.availableSkus.some(s => s.sku === reservedObj.sku);
    if (!exists) {
      this.availableSkus = [reservedObj, ...this.availableSkus];
    }
    this.catalogForm.patchValue({ selectedSku: reservedObj.sku });
    if(this.fullData.catalog.reservedSku) 
      this.catalogForm.get('selectedSku')?.disable();
    else 
      this.catalogForm.get('selectedSku')?.enable();
  }

  loadSkus(): void {
    this.data.getData('starlink/skus').subscribe((r: any) => {
      if (r?.result === 'success' && r?.data) {
        this.availableSkus = r.data.map((s: any) => ({ sku: s.value, label: s.display_name }));
        this.ensureReservedSkuInListAndSelect();
      } else {
        this.message.error(r?.message || 'Failed to load SKUs');
      }
    });
  }

  reserve(): void {
    const newSkuValue = this.catalogForm.value.selectedSku;
    const previousReserved = this.fullData?.catalog?.reservedSku.sku;
    const previousSkuValue = previousReserved == null
      ? null
      : previousReserved;
    const needToRelease = previousSkuValue != null && previousSkuValue !== newSkuValue;

    if(previousReserved && this.fullData.replayedLead)
      this.catalogDone.emit({ reservedSku: { sku: newSkuValue }, nextPage: 'documents', workOrderId: this.fullData.workOrderId });
    else {
    const reserveNew = () => {
      this.data.postData({ sku: newSkuValue, status: 'pending' }, 'starlink/updateSkuStatus').subscribe((r: any) => {
        if (r?.result === 'success') {
          const skuObj = this.availableSkus.find(s => s.sku === newSkuValue);
          if (skuObj) {
            this.createWo(skuObj);
            // this.catalogDone.emit({ reservedSku: skuObj, nextPage: 'documents' });
          } else {
            this.handleReserveError({ sku: newSkuValue, label: newSkuValue });
          }
        } else {
          this.handleReserveError({ sku: newSkuValue, label: newSkuValue });
        }
      }, e => {
        this.handleReserveError({ sku: newSkuValue, label: newSkuValue });
      });
    };
        if (needToRelease) {
      this.data.postData({ sku: previousSkuValue, status: 'available' }, 'starlink/updateSkuStatus').subscribe(
        () => reserveNew(),
        () => reserveNew()
      );
    } else {
      reserveNew();
    }
    }
  }

  createWo(skuObj: any) {
    let obj = {
        status: 'pending',
        customer_id: this.fullData.customerId,
        user_id: this.fullData.userId,
        provider: this.fullData.provider,
        provider_id: this.fullData.provider_id,
        distributor_id: this.fullData.distributorId,
        company_id: this.fullData.companyId,
        generic: {
          // starlink_order_number: starlinkOrderNumber,
          reserved_sku: this.catalogForm.value.selectedSku
        },
        order_id: null
      }
    this.data.postDataNoBodyDotBody(obj, 'work-order/create').subscribe((r: any) => {
        // this.orderDone.emit({ starlinkOrderNumber, nextPage: 'ihs-order', workOrderId: r.data.id });
        this.catalogDone.emit({ reservedSku: skuObj, nextPage: 'documents', workOrderId: r.data.id });
      }, e => {
        // this.notification.error('Error', 'Failed to create work order');
        this.handleReserveError({ sku: this.catalogForm.value.selectedSku, label: this.catalogForm.value.selectedSku });
        // console.log(e);
      })
  }

  handleReserveError(sku: StarlinkSku): void {
    this.modal.error({
      nzTitle: 'Reserve failed',
      nzContent: `Could not reserve ${sku.label}. It has been removed from the list.`
    });
    this.availableSkus = this.availableSkus.filter(s => s.sku !== sku.sku);
    this.catalogForm.patchValue({ selectedSku: null });
  }
}